import React, { useEffect } from "react";
import { } from 'react-redux';
import { } from "react-i18next";

import { } from '@lockerpm/design';

import commonComponents from "../../components/common";

import authServices from "../../services/auth";
import userServices from "../../services/user";
import commonServices from "../../services/common";
import coreServices from "../../services/core";

import global from "../../config/global";

import { getRouterByLocation } from '../../utils/common';

const Authenticate = () => {
  const { BusyOverlay } = commonComponents;

  useEffect(() => {
    if (global.jsCore) {
      loginWithToken();
    }
  }, [global.jsCore])

  const loginWithToken = async () => {
    const query = getRouterByLocation(window.location)?.query
    const token = query.token || null;
    if (token) {
      await coreServices.clear_keys();
      authServices.update_access_token(token);
      await userServices.get_account().then(async (response) => {
        if (!response.is_password_changed) {
          await commonServices.update_auth_info({
            token,
            token_type: 'Bearer',
            username: response.username,
            full_name: response.full_name
          }, false)
          global.navigate('CHANGE_INFORMATION', {}, {is_check_password: 0});
        } else {
          global.navigate('SIGN_IN');
        }
      }).catch((error) => {
        global.navigate('SIGN_IN');
      });
    } else {
      global.navigate('SIGN_IN')
    }
  }

  return (
    <div className="auth-page items-center">
      <BusyOverlay />
    </div>
  );
}

export default Authenticate;